import { matchRoutes } from 'react-router-dom';

const routes = [
  {
    path: '/auth/setup-account',
  },
  {
    path: '/auth/login',
  },
  {
    path: '/auth/resend-email-confirmation',
  },
  {
    path: '/auth/forgot-password',
  },
  {
    path: '/auth/reset-password',
  },
  {
    path: '/analytics',
  },
  {
    path: '/playground',
  },
  {
    path: '/:username',
  },
];

const paths = routes.map((route) => ({
  path: route.path,
}));

/**
 * @param pathname Pass the value from `useLocation()` to make a caller re-evaluate on
 *   client-side navigation; it defaults to reading the location directly.
 */
export const isPreviewRoute = (pathname: string = window.location.pathname) => {
  const route = matchRoutes(paths, pathname);
  return route?.some((r) => r.route.path === '/:username');
};
